module.exports = __webpack_public_path__ + "img/no-results.f958dbf6.png";